export default __webpack_public_path__ + "static/Montserrat-BlackItalic-4404f7c61ef37bcfd52a889abd7d512c.ttf";